import { types } from "mobx-state-tree";
import { UnmanagedPoolModel } from "./common";
import { NetworkingModel } from "./networking";

export const GenericProviderModel = types.model("Generic Provider", {
  location: types.optional(types.string, ""), // 'aws-eu-central-1' | 'aws-us-east-2' | 'aws-us-west-2' | 'gcp-me-west1' | 'gcp-us-east1'
  nodePools: types.array(UnmanagedPoolModel),
  networking: types.optional(NetworkingModel, () => NetworkingModel.create()),
});
